import React from "react";

/**
 * Button that sends the WhatsApp Message
 * to the External Member
 */

export default function SendRequest({
  handleSendNewRequest,
  isSendButtonEnabled,
}) {
  return (
    <button
      className="green-button"
      style={{width: 68}}
      onClick={handleSendNewRequest}
      disabled={!isSendButtonEnabled}
    >
      Send
    </button>
  );
}
